import { h } from 'preact';
export const CheckCircle = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("path", { d: "M22 11.08V12a10 10 0 1 1-5.93-9.14" }),
        h("polyline", { points: "22 4 12 14.01 9 11.01" })));
};
//# sourceMappingURL=check-circle.js.map